export default {
	methods: {
		Phone(payload) {
			if ( !payload ){
				return '-'
			}else {
		        if ( payload == 'start'){
					return 'Liga';
				}else{
		            let n = new String(payload);

					if (n.includes('.')) {
						return payload;
					}

					else {

						switch ( n.length ){
							case 11:
								return '(' + n.slice(0, 2) + ') ' + n.slice(2, 7) + '-' + n.slice(7);
								break;
	
							case 10:
								return '(' + n.slice(0, 2) + ') ' + n.slice(2, 6) + '-' + n.slice(6);
								break;
	
							case 9:
								return n.slice(0, 5) + '-' + n.slice(5);
								break;
	
							case 8:
								return n.slice(0, 4) + '-' + n.slice(4);
								break;
	
							default:
								return payload;
								break;
						}

					}

		        }
		    }
		},

		LimpaNum(payload) {
			const number = payload.replace( /[^0-9]/g, '');
    		return number;
		},

		DateFormat(payload) {
			return this.$moment(payload).format("DD/MM/YYYY");
		},

		TimeFormat(payload) {
			return this.$moment(payload).format("HH:mm:ss");
		},

		file_to_base64(payload) {
			const reader = new FileReader();

			reader.onload = ( theFile => {
				return e => {
					const binaryData   = e.target.result
					const base64String = window.btoa(binaryData)

					this.base64String = `data:${payload.type};base64,${base64String}`
					this.inputed = true
				}
			})(payload);

			reader.readAsBinaryString(payload);
		},

		priority_color(payload) {
			switch(payload) {
				case 1:
					return "primario";
					break;

				case 2:
					return "azul";
					break;

				case 3:
					return "atencao";
					break;

				case 4:
					return "vermelho";
					break;
				
				case 5:
					return "preto";
					break;
			}
		},

		seconds_to_stringtime(payload) {
			let time = new Date(null);
			time.setSeconds(payload);
			return time.toISOString().substr(11, 8);
		},

		get_status(payload) {
			switch (payload) {
				case 1:
					return "Em análise"
					break

				case 2:
					return "Encaminhada ao setor responsável"
					break

				case 3:
					return "Procede"
					break
			}
		},

		get_priorit(payload) {
			switch(payload) {
				case 1:
					return "Não visualizado";
					break;

				case 2:
					return "Irrelevante";
					break;
				
				case 3:
					return "Baixa";
					break;

				case 4:
					return "Média";
					break;

				case 5:
					return "Alta";
					break;
			}
		},

		get_user_fold(payload) {
			switch(payload) {
				case 1:
					return "Usuário";
					break;

				case 2:
					return "Administrador";
					break;

				case 3:
					return "Super administrador";
					break;
			}
		}
	} // Methods
}
